module.exports = __webpack_public_path__ + "files/55b64cd6c4907ad9231de5ecb0ab53db.png";